module.exports = __webpack_public_path__ + "img/AZD-5582.cd2ac8c8.png";